import axios from "axios";

// Add new action types
const SET_SPACE_AND_OBJECT = "SET_SPACE_AND_OBJECT";
const CLEAR_SPACE_AND_OBJECT = "CLEAR_SPACE_AND_OBJECT";

const initialState = {
  token:null,
  user: null,
  authorized: undefined,
  showBusinessForm: false,
  popupTxt: {
    text:"",
    type:""
  },
  lastTabIndex: "",
  lastTabId:"",
  redirect_path:"",
  setTokenInProcess:true,
  filterRates:null,
  getRatesTrigger:false,
  currentSpace: null,
  search: {
    query: "",
    tags: [],
    selectedSpaces: [],
    exactSearch: false
  },
  selectedSpaceId: null,
  selectedObjectId: null,
  aiChatResponse: null,
  reloadCurrentSpace: null,
  bottomNavVisible: true, // Default to visible
  chatOpen: false, // Track if chat is open
};

export const reducer = (state = initialState, action) => {
  
  switch (action.type) {
    case "SET_CURRENT_SPACE":
      return { ...state, currentSpace: action.payload.currentSpace };
        
    case "FILTER_RATES":
      return { ...state, filterRates:action.payload};

    case "GET_RATES":
      return { ...state, getRatesTrigger:action.payload};

    case "SET_TOKEN_IN_PROCESS":
      return { ...state, setTokenInProcess:action.payload};
    case "SET_REDIRECT_PATH":

    return { ...state, redirectPath:action.payload};

    case "SET_TOKEN":
      // SECURITY: Token is now stored in httpOnly cookies via Amplify
      // We only store it in Redux for UI state, not for sending in requests
      // Backend reads from cookies automatically - no Authorization header needed
      return { ...state, token:action.payload};
    case "SET_AUTHORIZED":
      return { ...state, authorized: true, user: action.user };


    case "SET_USER_DATA":

      return { ...state, user: action.payload, authorized: true};

    case "SET_UNAUTHORIZED":
      // SECURITY: Tokens are in httpOnly cookies, cleared by Amplify signOut
      // Only clear non-sensitive profile data from localStorage
      localStorage.removeItem("user_profile");
      return {
        ...state,
        authorized: false,
        token: null,
        user: {
          email: "",
          first_name: "",
          last_name: "",
          level: "",
          points: 0,
          token: "",
        },
      };
    case "SET_BUSINESS_FORM":
      return { ...state, showBusinessForm: action.payload };
    case "SET_POPUP":
      return { ...state, popupTxt: action.payload };
    case "SET_LAST_TAB_INDEX":
        return { ...state, lastTabIndex: action.payload };
    case "SET_LAST_TAB_ID":
          return { ...state, lastTabId: action.payload };
    case "GET_SPACES":
      return { ...state, performGetSpaces: action.payload.performGetSpaces };
    case "SET_DELETE_SPACE_DIALOG":
      return { ...state, deleteSpaceDialogOpen: action.payload.deleteSpaceDialogOpen };
    case "SET_COLLABORATORS_DIALOG_OPEN":
      return { ...state, collobartorsDialogOpen: action.payload.collobartorsDialogOpen };
    case "UPDATE_SEARCH":
      return { 
        ...state, 
        search: {
          ...state.search,
          ...action.payload
        }
      };
    case SET_SPACE_AND_OBJECT:
      return {
        ...state,
        selectedSpaceId: action.payload.spaceId,
        selectedObjectId: action.payload.objectId
      };
    case CLEAR_SPACE_AND_OBJECT:
      return {
        ...state,
        selectedSpaceId: null,
        selectedObjectId: null
      };
    case "AI_CHAT_RESPONSE":
      return { ...state, aiChatResponse: action.payload };
    case "RELOAD_CURRENT_SPACE":
      return { ...state, reloadCurrentSpace: action.payload };
    case "SET_BOTTOM_NAV_VISIBLE":
      return { ...state, bottomNavVisible: action.payload };
    case "SET_CHAT_OPEN":
      return { ...state, chatOpen: action.payload };
    default:
      return state;
  }
};

// Export action creators
export const setSpaceAndObject = (spaceId, objectId) => ({
  type: SET_SPACE_AND_OBJECT,
  payload: { spaceId, objectId }
});

export const clearSpaceAndObject = () => ({
  type: CLEAR_SPACE_AND_OBJECT
});
